import { createClient, SupabaseClient } from '@supabase/supabase-js';

// 定数定義
const TEST_SUPABASE_URL = 'https://test.supabase.co';
const TEST_SUPABASE_ANON_KEY = 'test-anon-key';

// Get environment variables with fallbacks for testing
let supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
let supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Handle placeholder values from .env file
if (supabaseUrl === 'your-supabase-project-url' || !supabaseUrl) {
  supabaseUrl = TEST_SUPABASE_URL;
}

if (supabaseAnonKey === 'your-supabase-anon-key' || !supabaseAnonKey) {
  supabaseAnonKey = TEST_SUPABASE_ANON_KEY;
}

// 有効なURLかどうかをチェック
const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

// 開発環境での警告（一時的に無効化）
if (process.env.NODE_ENV === 'development') {
  if (supabaseUrl === TEST_SUPABASE_URL || supabaseAnonKey === TEST_SUPABASE_ANON_KEY) {
    // Supabase環境変数が設定されていない場合の情報（開発モード）
    // 現在はDirectusのみを使用してテストしています
  }
}

// In production, ensure real environment variables are set
if (
  process.env.NODE_ENV === 'production' &&
  (supabaseUrl === TEST_SUPABASE_URL || supabaseAnonKey === TEST_SUPABASE_ANON_KEY)
) {
  throw new Error('Missing real Supabase environment variables in production');
}

// 有効なURLの場合のみSupabaseクライアントを作成
let supabase: SupabaseClient | null = null;

if (isValidUrl(supabaseUrl) && supabaseAnonKey && supabaseAnonKey !== TEST_SUPABASE_ANON_KEY) {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });
  } catch (error) {
    console.error('Failed to create Supabase client:', error);
    supabase = null;
  }
} else {
  console.warn('Supabase client not initialized: Invalid URL or missing credentials');
}

export { supabase };
